module.exports = __webpack_public_path__ + "media/images/noticia05-6777f4525fe551e4d4f7a4d7f5f086cf.jpeg";